import { Image, Table } from "antd";
import { useQuery } from "react-query";
import DashboardMaster from "../dashboard/dashboard-master-layout.component";
import React, { ReactElement } from "react";
import { tableColumns } from "../../lib/helpers.table";
import { Link } from "react-router-dom";
import { getGalleryList } from "./gallery.thunks";
import { GalleryInterface } from "./gallery.interface";

const GalleryList = (): ReactElement => {
  const moduleName = "galleries"; // we will use this as both the query name and the delete API endpoint
  const [page, setCurrentPage] = React.useState(0);

  const { data } = useQuery(
    [moduleName, { page }],
    () => getGalleryList({ page }),
    { keepPreviousData: true }
  );

  const tableData = data ? data.docs : [];

  const pagination = {
    current: data?.page,
    pageSize: data?.limit,
    hideOnSinglePage: true,
    showSizeChanger: false,
    total: data?.totalDocs,
    onChange: (page) => {
      pagination.current = page; // updates table pagination
      setCurrentPage(page); // re-fetch the api
    },
  };

  const columnData = [
    {
      title: "Name",
      dataIndex: "url",
      sorter: true,
      render: (text, doc) => (
        <Link to={`${moduleName}/` + doc._id}>{doc.url}</Link>
      ),
    },
    {
      title: "Image",
      dataIndex: "url",
      sorter: false,
      render: (text, record) => <Image width={200} src={record.localUrl} />,
    },
  ];

  const columns = tableColumns(
    columnData,
    { field: "File", url: `${moduleName}/` },
    { url: moduleName }
  );
  return (
    <>
      <DashboardMaster
        showAdd={true}
        title="Featured Gallery"
        addUrl={`/dashboard/${moduleName}/new`}
      >
        <Table
          rowKey={(doc: GalleryInterface) => doc._id}
          columns={columns}
          dataSource={tableData}
          pagination={pagination}
        />
      </DashboardMaster>
    </>
  );
};

export default GalleryList;
